// Shape edit dialog constants

export const TAG_OPTIONS = [
  "hangar",
  "parkable",
  "obstruction",
  "utilization",
  "reference_line",
  "spot",
  "zone",
  "egress_lane",
];

export const PREFIXED_COLORS = [
  {
    label: "Parking Area",
    stroke_style: "#3c6ce9",
    fill_style: "rgba(238, 239, 243, 0.10)",
  },
  {
    label: "Hazard Area",
    stroke_style: "#FF0000",
    fill_style: "#FF000030",
  },
  {
    label: "Taxi / Runway Area",
    stroke_style: "#eed202",
    fill_style: "#eed20230",
  },
  {
    label: "Free Space Area",
    stroke_style: "#00FF00",
    fill_style: "rgba(0, 255, 0, 0.38)",
  },
  {
    label: "Ground Vehicles Area",
    stroke_style: "#FCFAFF",
    fill_style: "#FCFAFF30",
  },
  {
    label: "Hangar Area",
    fill_style: "#c8cfde50",
    stroke_style: "#3e5d8c",
  },
];

export const SHAPE_COLORS = [
  "rgba(255, 0, 0, 0.5)",
  "rgba(255, 255, 0, 0.5)",
  "rgba(0, 255, 0, 0.5)",
  "rgba(0, 0, 255, 0.5)",
];

export const TEXT_COLORS = [
  "black",
  "white",
  "red",
  "green",
  "blue",
  "yellow",
  "purple",
  "orange",
  "pink",
  "brown",
];

export const LINE_STYLES = ["solid", "dashed", "dotted"];

export const TEXT_POSITION_OPTIONS = [
  { value: "start", label: "Start" },
  { value: "middle", label: "Middle" },
  { value: "end", label: "End" },
] as const;
